import * as moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { NumericFormat } from "react-number-format";
import { useLocation } from 'react-router-dom';
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import ReactToPrint from "react-to-print";
import { toast } from "react-toastify";
import { Button, Col, Row } from "reactstrap";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Icon,
} from "../../components/Component";
import Table from "../../components/react-table/Table";
import { GET, POST } from "../../helper/api";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";
import SignPrintComponent from "./Components/SignPrintComponent";

const PNReportPN = () => {
  const printRef = useRef();

  const history = useHistory();
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);

  const [data, setData] = useState([]);
  const [summary, setSummary] = useState({});

  const [dataEstimated, setDataEstimated] = useState([]);
  const [summaryEstimated, setSummaryEstimated] = useState({});
  const [showDataEstimated, setShowDataEstimated] = useState(false);

  const [loading, setLoading] = useState(false);
  const [timeNow, setTimeNow] = useState();
  const [smOption, setSmOption] = useState(false);
  const [filter, setFilter] = useState({
    startMonth: searchParams.get('startMonth') || moment().startOf('months').format("YYYY-MM-DD"),
    endMonth: searchParams.get('endMonth') || moment().format("YYYY-MM-DD"),
  });

  const colTable = [
    {
      Header: "Tên",
      accessor: (item) => item.name,
    },
    {
      Header: "Đầu kỳ(đ)",
      className: 'text-right',
      accessor: (item) => <NumericFormat
        displayType={"text"}
        value={item.firstAmount || 0}
        thousandsGroupStyle="thousand"
        thousandSeparator=","
        decimalScale={2}
      />,
    },
    {
      Header: "Tăng(đ)",
      className: 'text-right',
      accessor: (item) => <NumericFormat
        displayType={"text"}
        value={item.inAmount || 0}
        thousandsGroupStyle="thousand"
        thousandSeparator=","
        decimalScale={2}
      />,
    },
    {
      Header: "Giảm(đ)",
      className: 'text-right',
      accessor: (item) => <NumericFormat
        displayType={"text"}
        value={item.outAmount || 0}
        thousandsGroupStyle="thousand"
        thousandSeparator=","
        decimalScale={2}
      />,
    },
    {
      Header: "Cuối kỳ(đ)",
      className: 'text-right',
      accessor: (item) => <NumericFormat
        displayType={"text"}
        value={item.lastAmount || 0}
        thousandsGroupStyle="thousand"
        thousandSeparator=","
        decimalScale={2}
      />,
    },
  ];

  // Changing state value when searching name
  useEffect(() => {

    const newParams = new URLSearchParams({
      startMonth: filter.startMonth,
      endMonth: filter.endMonth,
    });
    history.replace({
      pathname: location.pathname,
      search: newParams.toString(),
    })

    setLoading(true);
    GET(`/pn/report-pn`, {
      startMonth: filter.startMonth,
      endMonth: filter.endMonth,
    }, true)
      .then(({ data: { data, dataEstimateds } }) => {
        setData([...data.in, ...data.out]);
        setSummary(data.summary)
        if (dataEstimateds) {
          setDataEstimated([...dataEstimateds.in, ...dataEstimateds.out])
          setSummaryEstimated(dataEstimateds.summary);
          setShowDataEstimated(true)
        } else {
          setShowDataEstimated(false)
        }

      })
      .finally(() => {
        setLoading(false);
      });
  }, [timeNow, filter]);


  const updateStatement = () => {
    POST(
      `/pn/get-first-summary-statement/calculated-previous-month`, {}, {}, true
    ).then(() => {
      toast.success('Cập nhật thành công')
      setTimeNow(moment().valueOf())
    });
  }

  return (
    <React.Fragment>
      <Head title="Báo cáo tổng kết"></Head>
      <Content>
        <BlockHead size="sm">
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page>Báo cáo tổng kết</BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="toggle-wrap nk-block-tools-toggle">
                <a
                  href="#more"
                  className="btn btn-icon btn-trigger toggle-expand mr-n1"
                  onClick={(ev) => {
                    ev.preventDefault();
                    setSmOption(!smOption);
                  }}
                >
                  <Icon name="more-v"></Icon>
                </a>
                <div
                  className="toggle-expand-content"
                  style={{ display: smOption ? "block" : "none" }}
                >
                  <ul className="d-lg-flex g-3 pt-1 pb-1 custom-filter-header justify-content-end">
                    <li>
                      <div className="form-control-wrap">
                        <input
                          type="date"
                          className="form-control  border-primary"
                          value={filter.endMonth}
                          onChange={(e) =>
                            setFilter({
                              ...filter,
                              endMonth: moment(e.target.value).format('YYYY-MM-DD'),
                              startMonth: moment(e.target.value).startOf('months').format('YYYY-MM-DD')
                            })
                          }
                        />
                      </div>
                    </li>
                    <li>
                      <div className="d-inline-block mr-3">
                        <Button onClick={updateStatement} className="ml-3">
                          Cập nhật lại đầu kỳ
                        </Button>
                      </div>
                    </li>
                    <li>
                      <div>
                        <ReactToPrint
                          trigger={() => <Button color="secondary">In</Button>}
                          content={() => printRef.current}
                          pageStyle={``}
                        />

                      </div>

                    </li>
                  </ul>
                </div>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>

        <Block>
          <div className="card card-bordered card-preview">
            <div className="card-inner">
              <div
                id="DataTables_Table_1_wrapper"
                className="dataTables_wrapper dt-bootstrap4 no-footer"
              >
                <Row>
                  <Col col={12}>
                    <div className="my-3" ref={printRef}>
                      <h5 className="text-center mt-2">
                        CÔNG TY TNHH CƠ KHÍ VẬN TẢI PHƯƠNG NAM
                      </h5>
                      <h5 className="text-center">Tổng kết</h5>
                      <Table
                        loading={loading}
                        columns={colTable}
                        data={data}
                        notShowPagi={true}
                        customRow={() => <tr className="font-weight-bold">
                          <td>{summary?.name}</td>
                          <td> <NumericFormat
                            displayType={"text"}
                            value={summary.firstAmount || 0}
                            thousandsGroupStyle="thousand"
                            thousandSeparator=","
                            decimalScale={2}
                          /></td>
                          <td> <NumericFormat
                            displayType={"text"}
                            value={summary.inAmount || 0}
                            thousandsGroupStyle="thousand"
                            thousandSeparator=","
                            decimalScale={2}
                          /></td>
                          <td> <NumericFormat
                            displayType={"text"}
                            value={summary.outAmount || 0}
                            thousandsGroupStyle="thousand"
                            thousandSeparator=","
                            decimalScale={2}
                          /></td>
                          <td> <NumericFormat
                            displayType={"text"}
                            value={summary.lastAmount || 0}
                            thousandsGroupStyle="thousand"
                            thousandSeparator=","
                            decimalScale={2}
                          /></td>
                        </tr>}
                      ></Table>
                      <SignPrintComponent />
                    </div>
                  </Col>


                </Row>
                <Row>
                  <Col col={12}>
                    <div className="my-3">
                      <h5 className="text-center">Tổng kết (Có cộng chi phí công nợ)</h5>
                      {showDataEstimated ? <Table
                        loading={loading}
                        columns={colTable}
                        data={dataEstimated}
                        notShowPagi={true}
                        customRow={() => <tr className="font-weight-bold">
                          <td>{summaryEstimated?.name}</td>
                          <td> <NumericFormat
                            displayType={"text"}
                            value={summaryEstimated.firstAmount || 0}
                            thousandsGroupStyle="thousand"
                            thousandSeparator=","
                            decimalScale={2}
                          /></td>
                          <td> <NumericFormat
                            displayType={"text"}
                            value={summaryEstimated.inAmount || 0}
                            thousandsGroupStyle="thousand"
                            thousandSeparator=","
                            decimalScale={2}
                          /></td>
                          <td> <NumericFormat
                            displayType={"text"}
                            value={summaryEstimated.outAmount || 0}
                            thousandsGroupStyle="thousand"
                            thousandSeparator=","
                            decimalScale={2}
                          /></td>
                          <td> <NumericFormat
                            displayType={"text"}
                            value={summaryEstimated.lastAmount || 0}
                            thousandsGroupStyle="thousand"
                            thousandSeparator=","
                            decimalScale={2}
                          /></td>
                        </tr>}
                      ></Table> : <h5>Đã chốt công nợ tháng</h5>}

                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </Block>
      </Content>
    </React.Fragment>
  );
};

export default PNReportPN;
